export const content = {
  tr: {
    nav: {
      products: 'Ürünler',
      why: 'Neden Mads',
      clients: 'Referanslar',
      contact: 'İletişim',
      cta: 'Teklif Al',
    },
    hero: {
      eyebrow: '// Türkiye • Ad-Tech Sales House',
      title: [
        'Geleceğin',
        'Global Reklam',
        'Ağlarıyla',
        'Büyümeyi Keşfedin.',
      ],
      accentIndex: 1,
      subtitle:
        'AI ve data odaklı reklam teknolojileriyle dijitalde sınırları kaldırın. Global partnerlerimizin premium envanterleri ve rich media üretimlerimizle; markanızın mobil büyüme ve performans hedeflerine doğrudan ivme kazandırıyoruz.',
      ctaPrimary: 'Teklif Al',
      ctaSecondary: 'Ürünleri İncele',
      metrics: [
        { k: 'AI-Driven', v: 'Akıllı Büyüme ve Optimizasyon' },
        { k: '%100', v: 'Marka Güvenliği (Brand Safety)' },
        { k: 'In-house', v: 'Dinamik Kreatif Üretim' },
      ],
    },
    marquee: [
      'DCO',
      'PROGRAMMATIC ADVERTISING',
      'RICH MEDIA',
      'CPI & CPA OPTIMIZATION',
      'EXCLUSIVE GLOBAL PARTNERS',
      'FRAUD-FREE INVENTORY',
      'MOBILE GROWTH',
      'AI-DRIVEN ADS',
      'USER ACQUISITION',
      'BRAND SAFETY',
      'PERFORMANCE MARKETING',
    ],
    products: {
      eyebrow: '// 01 — Platformlar',
      title: 'Global Teknoloji. Lokal Vizyon.',
      subtitle:
        'Dijitaldeki tüm büyüme hedefleriniz için tek bir merkez. Dünyanın önde gelen reklam ağlarıyla premium envanterlere doğrudan ulaşıyor, veriye dayalı ve kreatif odaklı kampanyalarla sınırları kaldırıyoruz.',
      items: [
        {
          slug: 'video',
          index: '01',
          name: 'İnteraktif Video & Kreatif Stüdyo',
          partner: 'In-House Studio • Exclusive',
          desc:
            'Standart video reklam kalıplarını yıkıyoruz. In-house kreatif stüdyomuzda tasarladığımız ClipFlip, branded player, etkileşimli preroll ve zengin rich media çözümleriyle marka mesajınızı yüksek etkileşimli ve ölçülebilir dijital deneyimlere dönüştürüyoruz.',
          tags: ['INTERACTIVE VIDEO', 'RICH MEDIA', 'IN-HOUSE PRODUCTION'],
        },
        {
          slug: 'turktelekom',
          index: '02',
          name: 'Türk Telekom Resmi İş Ortağı',
          partner: 'Türk Telekom • Exclusive',
          desc:
            'Türkiye’nin en büyük telekomünikasyon veri ağını (telco data) kampanyalarınızın merkezine alın. Exclusive partnerliğimiz sayesinde zenginleştirilmiş, güvenilir data segmentasyonlarına doğrudan erişerek hedef kitlenizi nokta atışı yakalayın.',
          tags: ['EXCLUSIVE PARTNER', 'TELCO DATA', 'PREMIUM AUDIENCE'],
        },
        {
          slug: 'dco',
          index: '03',
          name: 'DCO & Dinamik Kreatif Optimizasyonu',
          partner: 'Zuuvi • Exclusive Distribütör',
          desc:
            'Tek bir kreatiften binlerce kişiselleştirilmiş varyasyon yaratın. DCO teknolojimizi markanızın first-party datası, CRM verileri, lokasyon veya canlı ürün feed’i ile doğrudan entegre ederek, gerçek zamanlı ve hiper-kişiselleştirilmiş performans optimizasyonu sağlıyoruz.',
          tags: ['DCO', '1ST PARTY DATA', 'REAL-TIME'],
        },
        {
          slug: 'xiaomi',
          index: '04',
          name: 'Xiaomi Ads',
          partner: 'Xiaomi • Registered Agency',
          desc:
            'Türkiye’deki registered agency yetkimizle Mi Ads envanterine doğrudan erişim: Lock Screen tam sayfa branding ve display CPC kullanımlarıyla milyonlarca cihazda görünürlük.',
          tags: ['Lock Screen', 'OEM', 'Display CPC'],
        },
        {
          slug: 'push',
          index: '05',
          name: 'Push Notification',
          partner: 'Publisher Network',
          desc:
            'Geniş yayıncı ağı üzerinden web ve Chrome push bildirim gönderimi. Segmentli, planlı ve performans odaklı yeniden aktivasyon kanalı.',
          tags: ['Web Push', 'Chrome', 'Retention'],
        },
        {
          slug: 'app',
          index: '06',
          name: 'Mobil App Büyütme',
          partner: 'In-App + OEM',
          desc:
            'In-app ve OEM trafiğinde CPI ve CPA bazlı, fraud-free kampanyalar. Finans sektöründeki derin tecrübemizle KPI’a odaklı ölçekleme sağlarız.',
          tags: ['CPI', 'CPA', 'Fintech'],
        },
        {
          slug: 'native',
          index: '07',
          name: 'Native Ads & Performans Ağı',
          partner: 'Programmatic Network',
          desc:
            'Kullanıcı deneyimini bölmeyen native formatlar ve akıllı programatik satın alma stratejileriyle yüksek dönüşüm sağlıyoruz. Tıklama (CPC) ve aksiyon (CPA) odaklı, ölçülebilir büyüme elde edin.',
          tags: ['NATIVE', 'DISPLAY', 'PERFORMANCE', 'CPA / CPC'],
        },
      ],
    },
    why: {
      eyebrow: '// 02 — Dijital Çözüm Ortağınız',
      title: 'Neden Mads ile Büyümelisiniz?',
      chapters: [
        {
          n: '01',
          h: 'Doğrudan Erişim ve Exclusive Global Ağlar',
          p: 'Aracı değil, kaynağız. Türk Telekom, Xiaomi Ads ve dünyanın önde gelen platformlarının resmi iş ortağı olarak premium envanterlere ve birinci parti verilere (1st party data) kesintisiz erişim sağlıyoruz.',
        },
        {
          n: '02',
          h: 'In-House Stüdyo ve Hızlı Kreatif Üretim',
          p: 'Brief aşamasından canlı demoya sadece 48 saatte ulaşıyoruz. Kendi bünyemizdeki stüdyomuzla interaktif video, rich media formatları ve yapay zeka destekli DCO varyasyonlarını hızla hayata geçiriyoruz.',
        },
        {
          n: '03',
          h: 'Şeffaflık ve Marka Güvenliği (Brand Safety)',
          p: 'Tüm trafiğimizi doğrulanmış ve güvenli yayıncı ağlarından (fraud-free) sağlıyoruz. Gerçek zamanlı, mecra bazlı açık raporlama ile bütçenizin her kuruşunu optimize ediyoruz.',
        },
        {
          n: '04',
          h: 'Uçtan Uca ve Esnek Partnerlik Modeli',
          p: 'Ekibinizin dinamiğine göre şekil alıyoruz. İster medya planlama dahil tam hizmet (full-service) sunan bir dijital ajans, ister yapay zeka destekli programatik reklamcılık ve DSP entegrasyonu sağlayan teknoloji partneriniz olarak yanınızda yer alıyoruz.',
        },
      ],
    },
    clients: {
      eyebrow: '// 03 — Referanslar',
      title: 'Ajanslar ve markalar bize güveniyor.',
      subtitle: 'Yer tutucu logolar. Yakında güncellenecek.',
    },
    contact: {
      eyebrow: '// 04 — İletişim',
      title: 'Bir konuşma başlatalım.',
      subtitle:
        'Dijital hedeflerinizi bizimle paylaşın. Büyüme yolculuğunuza başlamak için hemen iletişime geçelim.',
      fields: {
        name: 'Ad Soyad',
        company: 'Şirket / Ajans',
        email: 'E-posta',
        phone: 'Telefon (opsiyonel)',
        brief: 'Brief / Mesaj',
      },
      submit: 'Gönder',
      submitting: 'Gönderiliyor...',
      success: 'Teşekkürler. Mesajınız iletildi — en kısa sürede dönüş yapacağız.',
      error: 'Bir şeyler ters gitti. Lütfen tekrar deneyin veya team@madsdigital.co adresine yazın.',
      required: 'Zorunlu alan',
    },
    footer: {
      tagline: 'Yeni nesil dijital reklam ve teknoloji ortağınız.',
      rights: 'Tüm hakları saklıdır.',
    },
  },
  en: {
    nav: {
      products: 'Products',
      why: 'Why Mads',
      clients: 'Clients',
      contact: 'Contact',
      cta: 'Get a proposal',
    },
    hero: {
      eyebrow: '// Türkiye • Ad-Tech Sales House',
      title: [
        'Grow in Türkiye',
        'with the',
        'global ad networks',
        'of the future.',
      ],
      accentIndex: 2,
      subtitle:
        'We connect AI- and data-driven advertising platforms with agencies and brands in Türkiye. Backed by premium inventory from our global partners, we deliver next-generation solutions across mobile growth, branding and performance — with rich-media creative production supporting every step.',
      ctaPrimary: 'Get a proposal',
      ctaSecondary: 'Explore products',
      metrics: [
        { k: 'AI-Driven', v: 'Smart growth & optimization' },
        { k: '100%', v: 'Brand safety' },
        { k: 'In-house', v: 'Dynamic creative production' },
      ],
    },
    marquee: [
      'DCO',
      'PROGRAMMATIC ADVERTISING',
      'RICH MEDIA',
      'CPI & CPA OPTIMIZATION',
      'EXCLUSIVE GLOBAL PARTNERS',
      'FRAUD-FREE INVENTORY',
      'MOBILE GROWTH',
      'AI-DRIVEN ADS',
      'USER ACQUISITION',
      'BRAND SAFETY',
      'PERFORMANCE MARKETING',
    ],
    products: {
      eyebrow: '// 01 — Platforms',
      title: 'Global technology. Local vision.',
      subtitle:
        'One home for every digital growth goal. We connect directly to premium inventory from the world’s leading ad networks and remove limits with data-driven, creative-led campaigns.',
      items: [
        {
          slug: 'video',
          index: '01',
          name: 'Interactive Video & Creative Studio',
          partner: 'In-House Studio • Exclusive',
          desc:
            'We break the standard video-ad mold. Our in-house creative studio produces ClipFlip, branded players, interactive prerolls and rich-media formats — turning your message into high-engagement, measurable digital experiences.',
          tags: ['INTERACTIVE VIDEO', 'RICH MEDIA', 'IN-HOUSE PRODUCTION'],
        },
        {
          slug: 'turktelekom',
          index: '02',
          name: 'Türk Telekom Official Partner',
          partner: 'Türk Telekom • Exclusive',
          desc:
            'Put Türkiye’s largest telco data network at the center of your campaigns. Our exclusive partnership gives direct access to enriched, trusted data segments — targeting audiences with pinpoint precision.',
          tags: ['EXCLUSIVE PARTNER', 'TELCO DATA', 'PREMIUM AUDIENCE'],
        },
        {
          slug: 'dco',
          index: '03',
          name: 'DCO & Dynamic Creative Optimization',
          partner: 'Zuuvi • Exclusive Distributor',
          desc:
            'Generate thousands of personalized variants from a single creative. We integrate our DCO tech with your first-party data, CRM, location or live product feeds — for real-time, hyper-personalized performance.',
          tags: ['DCO', '1ST PARTY DATA', 'REAL-TIME'],
        },
        {
          slug: 'xiaomi',
          index: '04',
          name: 'Xiaomi Ads',
          partner: 'Xiaomi • Registered Agency',
          desc:
            'Registered agency status in Türkiye gives direct access to Mi Ads: full-page Lock Screen branding and display CPC across millions of devices.',
          tags: ['Lock Screen', 'OEM', 'Display CPC'],
        },
        {
          slug: 'push',
          index: '05',
          name: 'Push Notification',
          partner: 'Publisher Network',
          desc:
            'Web and Chrome push messages across a large publisher network. Segmented, scheduled, performance-driven re-activation.',
          tags: ['Web Push', 'Chrome', 'Retention'],
        },
        {
          slug: 'app',
          index: '06',
          name: 'Mobile App Growth',
          partner: 'In-App + OEM',
          desc:
            'CPI and CPA campaigns across in-app and OEM traffic — fraud-free, KPI-driven scale. Deep track record in fintech.',
          tags: ['CPI', 'CPA', 'Fintech'],
        },
        {
          slug: 'native',
          index: '07',
          name: 'Native Ads & Performance Network',
          partner: 'Programmatic Network',
          desc:
            'Non-disruptive native formats combined with smart programmatic buying deliver high conversion. Click- (CPC) and action-driven (CPA) measurable growth.',
          tags: ['NATIVE', 'DISPLAY', 'PERFORMANCE', 'CPA / CPC'],
        },
      ],
    },
    why: {
      eyebrow: '// 02 — Your Digital Solution Partner',
      title: 'Why grow with Mads?',
      chapters: [
        {
          n: '01',
          h: 'Direct access & exclusive global networks',
          p: 'Not a middleman — the source. As the official partner of Türk Telekom, Xiaomi Ads and leading global platforms, we provide uninterrupted access to premium inventory and first-party data.',
        },
        {
          n: '02',
          h: 'In-house studio & fast creative production',
          p: 'From brief to live demo in 48 hours. Our in-house studio ships interactive video, rich-media formats and AI-powered DCO variants at speed.',
        },
        {
          n: '03',
          h: '100% transparency & brand safety',
          p: 'All traffic sourced from verified, fraud-free publisher networks. Real-time, placement-level open reporting optimizes every penny of your budget.',
        },
        {
          n: '04',
          h: 'End-to-end & flexible partnership',
          p: 'We shape ourselves around your team — whether as a full-service digital agency including media planning, or as your AI-powered programmatic and DSP integration technology partner.',
        },
      ],
    },
    clients: {
      eyebrow: '// 03 — Clients',
      title: 'Agencies and brands trust us.',
      subtitle: 'Placeholder logos. To be updated soon.',
    },
    contact: {
      eyebrow: '// 04 — Contact',
      title: 'Let’s start a conversation.',
      subtitle:
        'Share your digital goals with us. Let’s get in touch to kick off your growth journey.',
      fields: {
        name: 'Full name',
        company: 'Company / Agency',
        email: 'Email',
        phone: 'Phone (optional)',
        brief: 'Brief / Message',
      },
      submit: 'Send',
      submitting: 'Sending...',
      success: 'Thank you. Your message has been sent — we will get back shortly.',
      error: 'Something went wrong. Please try again or write to team@madsdigital.co.',
      required: 'Required',
    },
    footer: {
      tagline: 'Your next-generation digital advertising & technology partner.',
      rights: 'All rights reserved.',
    },
  },
};
